import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, AfterViewInit, ViewEncapsulation, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigService } from '../servizi/config/config.service';
import { Subscription } from 'rxjs';
import { GroupsHandlerService } from '../servizi/groups-handler.service';
import { GestioneLoginService } from '../servizi/login/gestione-login.service';
import { NamService } from '../servizi/nam/nam.service';
import { ProjectService } from '../servizi/nam/project.service';
import { RouterService } from '../servizi/router.service';
import { GestioneUtentiService } from '../servizi/utenti/gestione-utenti.service';
// import { WebsocketService } from '../servizi/websocket.service';
import ContextProvider from '../servizi/contextProvider';

@Component({
   selector: 'app-home',
   templateUrl: './home.component.html',
   styleUrls: ['./home.component.scss'],
   animations: [
      trigger('slideInOut', [
         state('in', style({
            transform: 'translate3d(-100%, 0, 0)',

         })),
         state('out', style({
            transform: 'translate3d(0, 0, 0)',
         })),
         transition('in => out', animate('300ms ease-in-out')),
         transition('out => in', animate('300ms ease-in-out'))
      ]),
      trigger('slideMap', [
         state('in', style({
            'margin-left': '0px'

         })),
         state('out', style({
            'margin-left': '300px'
         })),
         transition('in => out', animate('300ms ease-in-out')),
         transition('out => in', animate('300ms ease-in-out'))
      ]),
   ],
   encapsulation: ViewEncapsulation.None
})


export class HomeComponent implements AfterViewInit, OnInit {

   // Layout elements from configuration
   appHeaderEnabled: boolean;
   appMenuEnabled: boolean;
   appObjectInfoEnabled: boolean;
   leftMenuClosed: boolean;

   /** To Open/Close the menù */
   opened = true;
   menuState: string = 'out';

   userDataReady = false;

   config: any = null;

   private subs: Subscription[] = [];

   /** Constructor */
   constructor(
      private route: ActivatedRoute,
      private elementRef: ElementRef,
      private gestioneUtentiService: GestioneUtentiService,
      private groupsHandlerService: GroupsHandlerService,
      private gestioneLoginService: GestioneLoginService,
      private namService: NamService,
      private projectService: ProjectService,
      private routerSrv: RouterService,
      private configService: ConfigService,
      // private websocketService: WebsocketService
   ) { }

   /** ngOnInit */
   ngOnInit() {

      this.appMenuEnabled = ContextProvider.getContext().appMenu;
      this.appHeaderEnabled = ContextProvider.getContext().header;
      this.appObjectInfoEnabled = ContextProvider.getContext().objectInfo;
      //Sidebar closed by default
      if (!this.appMenuEnabled || ContextProvider.getContext().leftMenuClosed) {
         this.setSidebarVisibility();
      }

      // Microsoft Azure AD SSO
      // Gets user info and permissions
      this.gestioneUtentiService.userGetByToken({ 'tokens': [this.gestioneLoginService.getToken()] }).subscribe(
         (results: any) => {

            // Gestione profilo utente autenticato

            // User
            let user = results.data[0];

            // Sets user's properties
            if (!!user) {
               this.gestioneUtentiService.userSetProperties(user);
            }

            if (results.error === 0 && results.data.length > 0) {

               let groupsIds = [];

               if (!!results.data[0].groups) {
                  results.data[0].groups.forEach(group => {
                     groupsIds.push(group.id);
                  });
               }

               // If there are groups related to the user
               if (groupsIds.length > 0) {

                  // Gets user's group info and permissions
                  this.groupsHandlerService.groupGet({ ids: groupsIds }).subscribe(
                     (results: any) => {

                        if (results.error === 0 && results.data.length > 0) {
                           /**
                            * All user's permissions:
                            * 1 User with N permissions
                            * 1 User in N groups with N permissions
                            * */

                           let allPermissions = [];

                           // User's groups permissions
                           let allGroupsPermissions = [];

                           // Add permissions of each group the user belongs to
                           results.data.forEach(group => {
                              allGroupsPermissions = allGroupsPermissions.concat(group.permissions);
                           });

                           allPermissions = user.permissions.concat(allGroupsPermissions);

                           // Sets user's permission
                           this.gestioneUtentiService.userSetPermissions(allPermissions);

                           this.userDataReady = true;
                           //this.initializeWsConnection();
                        } else {
                           console.log("groupGet Error.", results);
                        }
                     }
                  );
               }
               // Else if there are no groups related to the user
               else {
                  /**
                   * All user's permissions:
                   * 1 User with N permissions
                   * */

                  // Sets user's permission
                  this.gestioneUtentiService.userSetPermissions(user.permissions);

                  this.userDataReady = true;
               }

            } else {
               console.log("userGet Error.", results);
            }

         });
   }

   initializeWsConnection() {

      // Initialize WS (Open WS channel)
      //this.websocketService.initializeWS();

      // Listen to WS messages
      this.subscriptions();

      // Connect WS (Open WS channel)
      //this.websocketService.connectWS();
   }

   private subscriptions() {

      // Listen to WS messages
      // this.subs.push(
      //    this.websocketService.socketEventServerMessage$.subscribe({
      //       next: (data) => {
      //          console.log("WS: Data from server--->", data);
      //       }
      //    })
      // );
   }

   /** AfterViewInit */
   ngAfterViewInit() {
      this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = 'white';
      //this.initializeWsConnection();
   }

   /** Apre o chiude il menù (metodo invocato dal bottone nel HeaderComponent) */
   setSidebarVisibility() {
      this.menuState = this.menuState === 'out' ? 'in' : 'out';
      this.opened = !this.opened;
   }

   // GB TEST 
   //    onSendMessageWs(){
   //       this.websocketService.sendMessageWs();
   //    }

   // disconnectWS(){
   //    this.websocketService.disconnectWS();
   // }

   // reconnectWS(){
   //    this.websocketService.reconnectWS();
   // }


}